import { RV_DEPRECIATION_PERIOD_YEARS } from '@/data/constants.js'

export const rvDepreciationPeriodOptions = (t) => {
    return RV_DEPRECIATION_PERIOD_YEARS.map((years) => ({
        label: `${years} ${t('§caf.years')}`,
        value: years,
    }))
}
